import { Component, Input, OnChanges } from '@angular/core';
import { slug } from '@assetaccountant/core/utils/slug';

@Component({
  selector: 'app-search-assets-name-cell',
  templateUrl: './search-assets-name-cell-renderer.component.html',
  styleUrls: ['./search-assets-name-cell-renderer.component.scss'],
  standalone: false,
})
export class SearchAssetsNameCellComponent implements OnChanges {
  @Input() data: {
    assetId: string;
    name: string;
    code?: string;
    description?: string;
  };

  routerLink?: string[];

  ngOnChanges() {
    this.routerLink = [`./${this.data.assetId}-${slug(this.data.name)}`];
  }
}
